import { Component, Input } from '@angular/core';
import { ReportBuilderService } from '../report-builder.service';
import { SchemaObject,TableColumn } from '../openapi-schema';

@Component({
    selector: 'app-dynamic-header',
    templateUrl: './dynamic-header.component.html',
    styleUrls: ['./dynamic-header.component.scss'],
    standalone: false
})
export class DynamicHeaderComponent {
  @Input() columns: TableColumn[] = [];

  getChildColumns(): TableColumn[] {
    return this.columns.reduce((acc: TableColumn[], col) => 
      [...acc, ...(col.children || [])], []);
  }
}
